import {
  clearAuthContext,
  enterTenantSwitch,
  exitTenantSwitch,
  getAdminAuthToken,
  getCurrentAuthToken,
  getTenantSwitchContext,
  isTenantSwitching,
  setAdminAuthToken,
  setCurrentAuthToken,
  type TenantSwitchContext,
} from "@/utils/tokenContext";
import { useState } from "react";

export default function useTokenModel() {
  const [version, setVersion] = useState(0);

  const refresh = () => {
    setVersion((prev) => prev + 1);
  };

  const setRequestId = (token: string) => {
    setCurrentAuthToken(token);
    refresh();
  };

  const setAdminId = (token: string) => {
    setAdminAuthToken(token);
    refresh();
  };

  const enterTenant = (context: TenantSwitchContext) => {
    enterTenantSwitch(context);
    refresh();
  };

  const exitTenant = () => {
    const context = exitTenantSwitch();
    refresh();
    return context;
  };

  const clearAll = () => {
    clearAuthContext();
    refresh();
  };

  return {
    version,
    currentToken: getCurrentAuthToken(),
    adminToken: getAdminAuthToken(),
    currentRequestId: getCurrentAuthToken(),
    adminRequestId: getAdminAuthToken(),
    tenantSwitching: isTenantSwitching(),
    tenantSwitchContext: getTenantSwitchContext(),
    setRequestId,
    setAdminId,
    enterTenant,
    exitTenant,
    clearAll,
    refresh,
  };
}
